module.exports = __webpack_public_path__ + "static/img/alexander_profile_1080x847.d3f3a5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alexander_profile_1080x847.jpg
// module id = /MaF
// module chunks = 0